/**
 * @param {Object}
 * @url {String} 上传接口返回的url
 * @data {String} 生成文件格式类型1:docx,2:doc,3:xlsx,4:xls,5:pptx,6:ppt
 * @scannerTab {String} scanner会员标识: 1,会员 2,非会员(scanner项目调用必传)
 */

import { axiosConvert } from "@/utils/axios";
import qs from "qs";

/**
 * 转换文件
 * @param {Object}
 * @params {Object} 传递参数
 * @name {String} 转换类型
 */

/**
 * 转换服务
 * @param {Object}
 * @url {String} 上传接口返回的url
 */
export const transFiles = (params) => axiosConvert.post(`/transform/convert`,
  params,
  {
    timeout: null,
    headers: {
      token: localStorage.getItem('token'),
      'Content-Type': 'application/json'
    }
  }
);

/**
 * 转换结果查询
 * @param {Object}
 * @returns
 */
export const convertResult = (params) => axiosConvert.post(`/transform/find_res`,
  params,
  {
    timeout: null,
    headers: {
      token: localStorage.getItem('token'),
      'Content-Type': 'application/json'
    }
  }
);

/**
 * 下载单个文件
 * @param {Object}
 * @filename {String} 文件名
 * @os {String} 请求端:EXE_WIN、WEB_WIN、MIN
 */
export const downloadOne = (params) => axiosConvert.post(`/file/transform`,
  qs.stringify({ os: 'WEB_WIN', ...params }), // 校验权限
  // qs.stringify({ ...params }),
  {
    responseType: 'blob',
    timeout: null,
    headers: {
      token: localStorage.getItem('token'),
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });

/**
 * 下载多个文件
 * @param {Object}
 * @urls {String} 多url用,拼接
 * @os {String} 请求端:EXE_WIN、WEB_WIN、MIN
 */
// export const downloadAll = (params) => axiosConvert.get(`/file/all_down_load?urls=${params}`,
export const downloadAll = (params) => axiosConvert.get(`/file/all_down_load?os=WEB_WIN&urls=${params}`, // 校验权限
  {
    responseType: 'blob',
    timeout: null,
    headers: {
      token: localStorage.getItem('token')
    }
  });

/**
 * 绑定转换记录
 * @param {Object}
 * @ {Array} 文件名称的数组
 */
export const bindingUrl = (params) => axiosConvert.post(`/record/binding`, params,
  {
    headers: {
      token: localStorage.getItem('token')
    }
  });
